import { Column } from 'primereact/column'
import { DataTable } from 'primereact/datatable'
import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { setAppTitle } from '../../../store/commonSlice'
import { routes } from '../../../utils/routes'
import { Link } from 'react-router-dom'

import { truck3 } from '../../../utils/images/imagepath'

import { avatar1 } from '../../../utils/images/imagepath'
import { useSelector } from 'react-redux'

function DriverProfile(props: any) {
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(setAppTitle('Drivers List'))
  }, [])

  const data = props?.profileData
  console.log(data)

  return (
    <>
      <div className='popup-canvas popup-canvas-view '>
        <div className='offcanvas-header popup-canvas-header'>
          <div className='offcanvas-header-edit'>
            <h5 id='offcanvasRightLabel' className='mt-0'></h5>
          </div>
          <a
            href='javascript:void(0);'
            className='clear-truck-list'
            data-bs-dismiss='offcanvas'
            aria-label='Close'
          >
            <i className='fas fa-xmark'></i>
          </a>
        </div>
        <div className='offcanvas-body popup-offcanvas-body popup-driver-view'>
          <div className='container p-0'>
            <div className='popup-driver-profile'>
              <div className='cc-driver-profile'>
                <h6>Driver Profile</h6>
              </div>
              <div className='cc-driver-content'>
                <div className='card success-border mb-3'>
                  <div className='card-body'>
                    <div className='row driver-widget'>
                      <div className='col-sm-4 col-md-4'>
                        <div className='driver-img'>
                          <img
                            src={avatar1}
                            className='img-fluid'
                            alt='Driver Profile'
                          />
                        </div>
                      </div>
                      <div className='col-sm-8 col-md-8 driver-list-info'>
                        <div className='driver-details'>
                          <div className='row'>
                            <div className='col-md-12'>
                              <div className='driver-base-profile mb-3'>
                                <h5>
                                  {data.driver_name}{' '}
                                  <span className='badge bg-light-success'>
                                    Active
                                  </span>
                                </h5>
                                <div className='driver-info mt-2'>
                                  <ul>
                                    <li>
                                      <i className='fa-regular fa-address-card'></i>{' '}
                                      <span>MFD 001</span>
                                    </li>
                                    <li>
                                      <i className='fa-solid fa-phone'></i>{' '}
                                      <span>{data.phone_number}</span>
                                    </li>
                                  </ul>
                                </div>
                                <a
                                  href='javascript:;'
                                  className='d-block mt-3 text-decoration-underline'
                                >
                                  Edit profile
                                </a>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className='card mt-2'>
                  <div className='card-body'>
                    <div className='row truck-widget'>
                      <div className='col-sm-4 col-md-4'>
                        <div className='truck-list-text'>
                          <p>Company Name</p>
                          <h6>ABC Company</h6>
                        </div>
                      </div>
                      <div className='col-sm-4 col-md-4'>
                        <div className='truck-list-text'>
                          <p>Licenece Number</p>
                          <h6>{data.license_number}</h6>
                        </div>
                      </div>
                      <div className='col-sm-4 col-md-4'>
                        <div className='truck-list-text'>
                          <p>Tin Number</p>
                          <h6>-</h6>
                        </div>
                      </div>
                      <div className='col-sm-4 col-md-4'>
                        <div className='truck-list-text'>
                          <p>Date of Birth</p>
                          <h6>06, June 1989</h6>
                        </div>
                      </div>
                      <div className='col-sm-4 col-md-4'>
                        <div className='truck-list-text'>
                          <p>Email ID</p>
                          <h6>{data.email}</h6>
                        </div>
                      </div>
                      <div className='col-sm-4 col-md-4'>
                        <div className='truck-list-text'>
                          <p>Join Date</p>
                          <h6>17, May 2015</h6>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className='popup-driver-profile'>
              <div className='cc-driver-profile'>
                <h6>Truck Details</h6>
              </div>
              <div className='row'>
                <div className='col-md-12'>
                  <div className='card'>
                    <div className='card-body'>
                      <ul
                        className='nav nav-pills driver-nav-pills mb-3'
                        id='pills-tab'
                        role='tablist'
                      >
                        <li className='nav-item' role='presentation'>
                          <button
                            className='nav-link active'
                            id='vechicle-home-tab'
                            data-bs-toggle='pill'
                            data-bs-target='#vechicle-details'
                            type='button'
                            role='tab'
                            aria-controls='vechicle-details'
                            aria-selected='true'
                          >
                            Vechicle Details
                          </button>
                        </li>
                        <li className='nav-item' role='presentation'>
                          <button
                            className='nav-link'
                            id='profile-home-tab'
                            data-bs-toggle='pill'
                            data-bs-target='#profile-details'
                            type='button'
                            role='tab'
                            aria-controls='profile-details'
                            aria-selected='false'
                          >
                            Other Details
                          </button>
                        </li>
                      </ul>
                      <div className='tab-content' id='pills-tabContent'>
                        <div
                          className='tab-pane fade show active'
                          id='vechicle-details'
                          role='tabpanel'
                          aria-labelledby='pills-home-tab'
                        >
                          <div className='driver-active-truck'>
                            <div className='row'>
                              <div className='col-md-8 view-vechcile-info'>
                                <h5>{data.model_name} ( AB06 CD 1234 )</h5>
                                <p className='mt-3'>
                                  The distinctly curved windshield and angular
                                  profile will be the first things you notice.
                                  But that’s just the beginning of the
                                  aerodynamic and powertrain breakthroughs found
                                  throughout the all-new VNL. Together they
                                  create up to a 10% improvement in fuel
                                  efficiency versus our previous model.
                                </p>
                              </div>
                              <div className='col-md-4'>
                                <img
                                  className='avatar-img mt-4 mt-sm-0'
                                  src={truck3}
                                  alt='Vechicle Image'
                                />
                              </div>
                            </div>
                            <div className='row mt-3'>
                              <div className='col-md-12 view-vechcile-info'>
                                <h5>About Vechicle</h5>
                                <div className='row'>
                                  <div className='col-md-12 about-vechicle'>
                                    <ul>
                                      <li>
                                        <span className='vech-title'>
                                          Modal
                                        </span>
                                        <span>Ram pickup</span>
                                      </li>
                                      <li>
                                        <span className='vech-title'>
                                          Engine
                                        </span>
                                        <span>
                                          405-500 hp - 1450-1900 lb-ft.
                                        </span>
                                      </li>
                                      <li>
                                        <span className='vech-title'>
                                          Year of Manufacture
                                        </span>
                                        <span>{data.vehicle_year}</span>
                                      </li>
                                      <li>
                                        <span className='vech-title'>
                                          Fule Type
                                        </span>
                                        <span>Diesel</span>
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className='row mt-3'>
                              <div className='col-md-12 view-vechcile-info'>
                                <h5>Checklist</h5>
                                <div className='row'>
                                  <div className='col-md-12 about-vechicle'>
                                    <ul>
                                      <li>
                                        <span className='vech-title'>
                                          Checklist
                                        </span>
                                        <span>
                                          <a href='check-list.html'>
                                            View Checklist
                                          </a>
                                        </span>
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          className='tab-pane fade'
                          id='profile-details'
                          role='tabpanel'
                          aria-labelledby='pills-home-tab'
                        >
                          <h5>Other Details</h5>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
export default DriverProfile
